import _ from 'lodash'

/**
 * Search dynamique avec AJAX
 */
const searchBar = document.querySelector('.searchform')
if (searchBar) {
  const searchField = searchBar.querySelector('.search-field')
  const resultsWrapper = document.querySelector('.results-list');
  searchField.addEventListener('keyup', _.throttle(() => { // Quand on tape dans la barre de recherche
    const value = searchField.value

    if (value.length < 3) resultsWrapper.style.display = 'none';
    // Requete API JSON Wordpress
    if (value.length >= 3) {
      fetch('/wp-json/wp/v2/search?search=' + value, {
        method: 'GET',
      })
        .then(response => response.json())
        .then(data => {
          resultsWrapper.innerHTML = ''
          if (data.length) {
            resultsWrapper.style.display = 'block';
            data.map(item => {
              const link = document.createElement('a')
              link.setAttribute('href', item.url)
              link.innerHTML = item.title

              resultsWrapper.appendChild(link)
            })
          } else {
            resultsWrapper.style.display = 'none';
          }
        });
    }
  }, 500))
}


// WEBPACK FOOTER //
// ./scripts/search.js